import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "pass",
  computed: {
    ...userVuex.mapState(["isLogin", "balanceInfo", "userInfo", "didInfo", "settingInfo"])
  },
  data() {
    const wayList = [{
      name: "Invite Fans",
      path: "/friends",
      icon: "icon-fan"
    }, {
      name: "Complete Tasks",
      path: "/task",
      icon: "icon-task"
    }, {
      name: "Upgrade VIP",
      path: "/vip",
      icon: "icon-vip"
    }];
    return {
      wayList
    };
  }
};